var widgetsServiceObj =
{
    getCount(searchOrderParams, filter) {
        var params = {
            SearchFilterObject: JSON.stringify(searchOrderParams),
            SearchFilter: filter,
        };

        return axios.post('api/Order/GetWidgetOrdersCount', params);
    },

    getTotalAmount(searchOrderParams, filter) {
        var params = {
            SearchFilterObject: JSON.stringify(searchOrderParams),
            SearchFilter: filter,
        };

        return axios.post('api/Order/GetWidgetOrdersTotalAmount', params);
    },

    getPaymentAmount(searchOrderParams, filter) {
        var params = {
            SearchFilterObject: JSON.stringify(searchOrderParams),
            SearchFilter: filter,
        };

        return axios.post('api/Order/GetWidgetOrdersPaymentsAmount', params);
    },
}
export const widgetsService = widgetsServiceObj;
